import React, { ReactElement, useState, useEffect, useContext } from "react";
import { i18n } from "../../../i18n";

// Styles
import "./multiLanguage.scss";

import { useSelector, shallowEqual } from "react-redux";

const MultiLanguage = (props): ReactElement => {
  const [currentLang, setCurrentLang] = useState("");
  const [isList, setIsList] = useState(false);

  const { generalSettings } = useSelector(
    ({ generalSettings }) => ({
      generalSettings,
    }),
    shallowEqual
  );

  useEffect(() => {
    let mounted = true;
    setIsList(props.list);
    setCurrentLang(i18n.language);
    i18n.on("languageChanged", (ln) => {
      if (mounted) setCurrentLang(ln);
    });
    return () => {
      mounted = false;
    };
  }, []);
  const changeLanguage = (lng) => {
    window.localStorage.setItem("default_lang", lng);
    i18n.changeLanguage(lng);
  };

  return (
    <>
      {generalSettings?.languageSelectEnabled && (
        <>
          {isList ? (
            <div className="tm__language">
              <div className="d-flex px-2">
                <i className="bi bi-globe2 fs-7 me-2"></i>
                <label className="fs-7">Languages</label>
              </div>
              <ul className="border-top border-bottom list-style-none p-0 my-2">
                <li>
                  <button
                    className={`dropdown-item border-0 fs-7 fw-bold ${
                      currentLang === "fr" ? "active" : ""
                    }`}
                    onClick={() => changeLanguage("fr")}>
                    français
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item border-0 fs-7 fw-bold ${
                      currentLang === "en" ? "active" : ""
                    }`}
                    onClick={() => changeLanguage("en")}>
                    english
                  </button>
                </li>
              </ul>
            </div>
          ) : (
            <div className="tm__language dropdown">
              <button
                className="btn btn-secondary dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false">
                <i className="bi bi-globe2 me-2"></i>{" "}
                {currentLang === "fr" ? "français" : "english"}
              </button>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <button
                    className={`dropdown-item border-0 fs-7 fw-bold ${
                      currentLang === "fr" ? "active" : ""
                    }`}
                    onClick={() => changeLanguage("fr")}>
                    français
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item border-0 fs-7 fw-bold ${
                      currentLang === "en" ? "active" : ""
                    }`}
                    onClick={() => changeLanguage("en")}>
                    english
                  </button>
                </li>
              </ul>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default MultiLanguage;
